/* Phagwara Watch – theme.js */
(function () {
  'use strict';
  var PW = window.PW || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var v = Math.round(Number(cents) || 0) / 100;
    return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  PW.money = money;

  function waUrl(text) {
    return 'https://wa.me/' + (PW.wa || '919814935485') + '?text=' + encodeURIComponent(text);
  }
  PW.waUrl = waUrl;

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  PW.toast = toast;

  /* Drawer */
  function openDrawer() { document.documentElement.classList.add('drawer-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { document.documentElement.classList.remove('drawer-open'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    var tg = e.target.closest('.dn-toggle');
    if (tg) { tg.parentElement.classList.toggle('open'); }
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault(); closeDrawer();
      var sb = $('[data-search-bar]');
      if (sb) { sb.classList.toggle('open'); var i = $('input', sb); if (i && sb.classList.contains('open')) i.focus(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeModal(); } });

  /* Back to top */
  var tt = $('[data-to-top]');
  if (tt) {
    window.addEventListener('scroll', function () { tt.classList.toggle('show', window.scrollY > 600); }, { passive: true });
    tt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Cart count */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; }).catch(function () {});
  }
  PW.refreshCart = refreshCart;

  function addToCart(id, qty, btn) {
    if (!id) return Promise.resolve();
    if (btn) btn.setAttribute('disabled', '');
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, Number(qty) || 1) }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { toast('Added to cart ✓'); return refreshCart(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  }
  PW.addToCart = addToCart;

  /* Product card qty + add */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var wrap = q.closest('[data-qty-wrap]'); var inp = wrap && $('input', wrap);
      if (inp) { var v = (parseInt(inp.value, 10) || 1) + Number(q.getAttribute('data-qty')); inp.value = Math.max(1, v); inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var a = e.target.closest('[data-card-add]');
    if (a) {
      e.preventDefault();
      var card = a.closest('[data-card]'); var qi = card && $('[data-qty-wrap] input', card);
      addToCart(a.getAttribute('data-card-add'), qi ? qi.value : 1, a);
    }
  });

  /* Wishlist */
  var WKEY = 'pw_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function setWish(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} paintWish(); }
  function paintWish() {
    var list = getWish();
    $$('[data-wish]').forEach(function (b) { var on = list.indexOf(b.getAttribute('data-wish')) > -1; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'); var list = getWish(); var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); } else { list.push(h); toast('Added to wishlist ♥'); }
    setWish(list);
  });
  paintWish();

  var wishPage = $('[data-wishlist-page]');
  if (wishPage) {
    var list = getWish(); var grid = $('[data-wishlist-grid]', wishPage);
    if (!list.length) { grid.innerHTML = '<p class="empty" style="grid-column:1/-1">Your wishlist is empty. Tap ♡ on any watch to save it here.</p>'; }
    else {
      Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (items) {
          grid.innerHTML = items.filter(Boolean).map(function (p) {
            var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
            var cmp = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s><span class="sale">' + money(p.price) + '</span>' : '<span>' + money(p.price) + '</span>';
            return '<div class="card" data-card><a class="card-media" href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div class="card-actions"><button class="card-wish on" data-wish="' + p.handle + '" aria-label="Remove">♥ Remove</button></div>' +
              '<a href="/products/' + p.handle + '" class="card-title">' + p.title + '</a><div class="price">' + cmp + '</div></div>';
          }).join('');
        });
    }
  }

  /* Sliders */
  $$('[data-slider]').forEach(function (sl) {
    var track = $('.slider-track', sl); if (!track) return;
    var slides = $$(':scope > *', track); var dotsWrap = $('.dots', sl);
    function idx() { var w = slides[0] ? slides[0].getBoundingClientRect().width : 1; return Math.round(track.scrollLeft / w); }
    function go(i) { var w = slides[0].getBoundingClientRect().width; var max = slides.length - Math.round(track.clientWidth / w); if (i < 0) i = max; if (i > max) i = 0; track.scrollTo({ left: i * w, behavior: 'smooth' }); }
    if (dotsWrap && slides.length > 1) {
      var perView = Math.max(1, Math.round(track.clientWidth / (slides[0].getBoundingClientRect().width || 1)));
      var count = slides.length - perView + 1;
      for (var i = 0; i < count; i++) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Slide ' + (i + 1)); (function (n) { d.addEventListener('click', function () { go(n); }); })(i); dotsWrap.appendChild(d); }
    }
    function paint() { var i = idx(); $$('button', dotsWrap || document.createElement('div')).forEach(function (d, n) { d.classList.toggle('active', n === i); }); sl.dispatchEvent(new CustomEvent('slide', { detail: i })); }
    track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(paint, 80); }, { passive: true });
    paint();
    var p = $('.slider-arrow.prev', sl), n = $('.slider-arrow.next', sl);
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    sl._go = go;
    var auto = Number(sl.getAttribute('data-autoplay')) || 0;
    if (auto && slides.length > 1) {
      var timer = setInterval(function () { if (!document.hidden) go(idx() + 1); }, auto * 1000);
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    }
  });

  /* Product page */
  var pdp = $('[data-pdp]');
  var modal = $('[data-cod-modal]');
  function closeModal() { if (modal) { modal.classList.remove('open'); document.body.style.overflow = ''; } }

  if (pdp) {
    var data = JSON.parse($('[data-product-json]', pdp).textContent);
    var product = data.product; var current = data.selected;
    var idInput = $('[name="id"]', pdp);
    var qtyInput = $('[data-pdp-qty]', pdp);
    var gallery = $('.pdp-gallery [data-slider]', pdp);

    function renderVariant(v) {
      if (!v) return;
      current = v; if (idInput) idInput.value = v.id;
      var pr = $('[data-pdp-price]', pdp);
      if (pr) pr.innerHTML = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s><span class="sale">' + money(v.price) + '</span>' : '<span>' + money(v.price) + '</span>';
      var sv = $('[data-save]', pdp);
      if (sv) { if (v.compare_at_price > v.price) { sv.style.display = ''; sv.textContent = 'You save ' + money(v.compare_at_price - v.price) + ' (' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF)'; } else sv.style.display = 'none'; }
      $$('[data-buy-btn]').forEach(function (b) { if (v.available) b.removeAttribute('disabled'); else b.setAttribute('disabled', ''); });
      var atc = $('[data-atc-label]'); if (atc) atc.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_media && gallery) {
        var slides = $$('.slide', gallery); slides.forEach(function (s, i) { if (Number(s.getAttribute('data-media-id')) === v.featured_media.id && gallery._go) gallery._go(i); });
      }
      if (history.replaceState && product.variants.length > 1) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    pdp.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option]')) return;
      var sel = $$('[data-option]', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      renderVariant(v);
    });

    /* thumbs */
    if (gallery) {
      var thumbs = $$('.thumbs button', pdp);
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { gallery._go && gallery._go(i); }); });
      gallery.addEventListener('slide', function (e) { thumbs.forEach(function (t, i) { t.classList.toggle('active', i === e.detail); }); });
      var z = $('.pdp-zoom', pdp);
      if (z) z.addEventListener('click', function () { var s = $$('.slide', gallery)[Math.round($('.slider-track', gallery).scrollLeft / $('.slider-track', gallery).clientWidth)]; var img = s && $('img', s); if (img) window.open(img.getAttribute('data-full') || img.src, '_blank'); });
    }

    /* Add to cart */
    var form = $('[data-pdp-form]', pdp);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(current.id, qtyInput ? qtyInput.value : 1, $('[type=submit]', form)); });

    /* WhatsApp chat */
    $$('[data-wa-product]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var vt = product.variants.length > 1 ? ' (' + current.title + ')' : '';
        var msg = 'Hi ' + (PW.shop || 'Phagwara Watch').trim() + ' 👋\nMujhe is watch ke baare mein jaankari chahiye:\n\n⌚ ' + product.title + vt + '\n💰 ' + money(current.price) + '\n🔗 ' + location.origin + '/products/' + product.handle;
        window.open(waUrl(msg), '_blank');
      });
    });

    /* Sticky buy bar */
    var sticky = $('[data-sticky-buy]'); var mainBtns = $('.pdp-buttons', pdp);
    if (sticky && mainBtns && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainBtns);
    }

    /* COD modal */
    if (modal) {
      var cform = $('[data-cod-form]', modal);
      var cq = $('[name="qty"]', cform);
      function paintSummary() {
        var q = Math.max(1, parseInt(cq.value, 10) || 1);
        var sub = current.price * q; var adv = (Number(PW.advance) || 0) * 100;
        $('[data-cod-img]', modal).src = (current.featured_image && current.featured_image.src) || data.image || '';
        $('[data-cod-title]', modal).textContent = product.title + (product.variants.length > 1 ? ' – ' + current.title : '');
        $('[data-cod-unit]', modal).textContent = money(current.price) + ' × ' + q;
        $('[data-cod-sub]', modal).textContent = money(sub);
        $('[data-cod-adv]', modal).textContent = '– ' + money(adv);
        $('[data-cod-due]', modal).textContent = money(Math.max(0, sub - adv));
        $('[data-cod-total]', modal).textContent = money(sub);
      }
      $$('[data-cod-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault(); if (!current.available) return;
          cq.value = qtyInput ? qtyInput.value : 1; paintSummary();
          modal.classList.add('open'); document.body.style.overflow = 'hidden';
          setTimeout(function () { var f = $('input[name="name"]', cform); f && f.focus(); }, 60);
        });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-cod-close]')) closeModal(); });
      cform.addEventListener('input', function (e) { var f = e.target.closest('.field'); if (f) f.classList.remove('err'); if (e.target === cq) paintSummary(); });
      cform.addEventListener('change', function (e) { if (e.target === cq) paintSummary(); });

      var saved = {}; try { saved = JSON.parse(localStorage.getItem('pw_cod')) || {}; } catch (er) {}
      ['name', 'phone', 'address', 'landmark', 'city', 'pincode', 'state'].forEach(function (k) { var el = cform.elements[k]; if (el && saved[k]) el.value = saved[k]; });

      var pin = cform.elements.pincode;
      pin.addEventListener('input', function () {
        pin.value = pin.value.replace(/\D/g, '').slice(0, 6);
        if (pin.value.length === 6) {
          fetch('https://api.postalpincode.in/pincode/' + pin.value).then(function (r) { return r.json(); }).then(function (d) {
            var po = d && d[0] && d[0].PostOffice && d[0].PostOffice[0];
            if (po) { if (!cform.elements.city.value) cform.elements.city.value = po.District; var st = cform.elements.state; $$('option', st).forEach(function (o) { if (o.value.toLowerCase() === String(po.State).toLowerCase()) st.value = o.value; }); }
          }).catch(function () {});
        }
      });
      var ph = cform.elements.phone;
      ph.addEventListener('input', function () { ph.value = ph.value.replace(/\D/g, '').slice(-10); });

      cform.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = cform.elements; var ok = true;
        function bad(el) { el.closest('.field').classList.add('err'); if (ok) el.focus(); ok = false; }
        if (f.name.value.trim().length < 2) bad(f.name);
        if (!/^[6-9]\d{9}$/.test(f.phone.value)) bad(f.phone);
        if (f.address.value.trim().length < 8) bad(f.address);
        if (f.city.value.trim().length < 2) bad(f.city);
        if (!/^\d{6}$/.test(f.pincode.value)) bad(f.pincode);
        if (!f.state.value) bad(f.state);
        if (!ok) return;
        var d = {}; ['name', 'phone', 'address', 'landmark', 'city', 'pincode', 'state'].forEach(function (k) { d[k] = (f[k].value || '').trim(); });
        try { localStorage.setItem('pw_cod', JSON.stringify(d)); } catch (er) {}
        var q = Math.max(1, parseInt(cq.value, 10) || 1); var sub = current.price * q; var adv = (Number(PW.advance) || 0) * 100;
        var vt = product.variants.length > 1 ? '\n🎨 Variant: ' + current.title : '';
        var msg = '🛒 *NEW COD ORDER – ' + (PW.shop || 'Phagwara Watch').trim().toUpperCase() + '*\n\n' +
          '⌚ *' + product.title + '*' + vt + '\n🔢 Qty: ' + q + '\n💰 Total: ' + money(sub) + '\n🔗 ' + location.origin + '/products/' + product.handle + '?variant=' + current.id + '\n\n' +
          '👤 *Name:* ' + d.name + '\n📞 *Phone:* ' + d.phone + '\n🏠 *Address:* ' + d.address + (d.landmark ? ', ' + d.landmark : '') + '\n🏙️ *City:* ' + d.city + '\n📮 *Pincode:* ' + d.pincode + '\n🗺️ *State:* ' + d.state + '\n\n' +
          '💵 *Payment:* Cash on Delivery\n✅ ' + money(adv) + ' advance pay karne ke liye ready hoon. Please order confirm karein.';
        var btn = $('[type=submit]', cform); btn.setAttribute('disabled', '');
        window.location.href = waUrl(msg);
        setTimeout(function () { btn.removeAttribute('disabled'); closeModal(); toast('WhatsApp pe order bhejiye – team confirm karegi ✓'); }, 1500);
      });
    }
  }

  /* Cart page: order on WhatsApp */
  var waCart = $('[data-wa-cart]');
  if (waCart) waCart.addEventListener('click', function (e) {
    e.preventDefault();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var lines = c.items.map(function (i, n) { return (n + 1) + '. ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' × ' + i.quantity + ' = ' + money(i.final_line_price); }).join('\n');
      var msg = 'Hi ' + (PW.shop || 'Phagwara Watch').trim() + ' 👋\nMain ye order karna chahta/chahti hoon (COD):\n\n' + lines + '\n\n💰 Total: ' + money(c.total_price) + '\n\nNaam / Address / Pincode:';
      window.open(waUrl(msg), '_blank');
    });
  });

  /* Generic WA chat links */
  $$('[data-wa-chat]').forEach(function (a) { a.setAttribute('href', waUrl(a.getAttribute('data-wa-chat') || 'Hi Phagwara Watch 👋')); });

  refreshCart();
})();
